let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("aviQH")).then(() => parcelRequire('5pz6a'));